export default __webpack_public_path__ + "static/media/popple.52a316ba.png";